import React from 'react';
var defaultProps = {};
export default function Label(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React.createElement("span", {
    className: "social-platform-label"
  }, label, ':', "\xA0");
}
Label.defaultProps = defaultProps;